import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import Config from "config";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import { makeSelectStyles } from "../../common/selectStyles";

function EditDocumentationGenerale() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const layout = localStorage.getItem("layoutMode");

  const [loading, setLoading] = useState(true);
  const [wait, setWait] = useState(1000);
  const token = localStorage.getItem("auth_token_" + api);
  const [configData, setConfigData] = useState([]);
  const [existingFile, setExistingFile] = useState(null);
  const [newFileUrl, setNewFileUrl] = useState(null);
  const fileInputRef = useRef(null);

  const [activeTab, setActiveTab] = useState("details");
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);
  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };

  const styles = makeSelectStyles(layout);

  // Formulaire
  const [formData, setFormData] = useState({
    Nom: "",
    Catégorie: { label: null, value: null },
    Type: { label: null, value: null },
    Année: { label: null, value: null },
    Fichier: null,
  });

  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({ ...prevState, [key]: value }));
    if (key === "Catégorie" && value?.value) {
      getTypes(value.value);
    }
  };

  //prévisualisation du nouveau fichier
  useEffect(() => {
    if (formData["Fichier"]) {
      const url = URL.createObjectURL(formData["Fichier"]);
      setNewFileUrl(url);
      return () => URL.revokeObjectURL(url);
    } else {
      setNewFileUrl(null);
    }
  }, [formData["Fichier"]]);

  // Donnees pour les selects
  const [categoriesData, setCategoriesData] = useState({ data: [] });
  const [typesData, setTypesData] = useState({ data: [] });
  const [anneesData, setAnneesData] = useState({ data: [] });

  const renderSelectOptions = (data) => [
    {
      options: data.map((item) => ({
        label: item.label,
        value: item.value ?? item.id,
      })),
    },
  ];

  const getCategories = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/documentation_generales/categories_documents`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => response.json())
        .then((result) => {
          setCategoriesData(result);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getTypes = async (categoriesDocumentId) => {
    try {
      fetch(`https://www.fluxod.com/${api}/documentation_generales/types_documents?categories_document_id=${categoriesDocumentId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => response.json())
        .then((result) => {
          setTypesData(result);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getAnnees = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/documentation_generales/annees`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => response.json())
        .then((result) => {
          setAnneesData(result);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // Recuperation des donnees d'édition
  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/documentation_generales/${id}/edit`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 403) navigate(`${backUrl}/forbidden`);
      if (response.status === 500) navigate(`${backUrl}/error`);
      if (response.status === 203) navigate(`${backUrl}/error404`);
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const result = await response.json();
      setConfigData(result);

      
      const identification =
        result?.detail_documentation_generale?.["Identification"] || result || {};

      setFormData((prev) => ({
        ...prev,
        Nom: identification["Nom"] || identification["nom"] || "",
        Catégorie: identification["Catégorie"] || (
          identification["categories_document_id"]
            ? { label: identification["categories_document"] || null, value: identification["categories_document_id"] }
            : { label: null, value: null }
        ),
        Type: identification["Type"] || (
          identification["types_document_id"]
            ? { label: identification["types_document"] || null, value: identification["types_document_id"] }
            : { label: null, value: null }
        ),
        Année: identification["Année"] || (
          identification["annee_id"]
            ? { label: identification["annee"] || null, value: identification["annee_id"] }
            : { label: null, value: null }
        ),
      }));
      setExistingFile(identification["Fichier"] || null);
    } catch (error) {
      console.error(error);
    }
  };

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("editSuccess", "true");
    const previousPath = localStorage.getItem("previousPath_" + api);
    navigate(previousPath || -1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Validation: si l'utilisateur a supprimé le fichier et submit
    if (!formData["Fichier"] && !existingFile) {
      toast.error("Le fichier est obligatoire");
      return;
    }

    try {
      setLoading(true);
      const body = new FormData();
      body.append("id", id);
      body.append("nom", formData["Nom"]);
      body.append("categories_document_id", formData["Catégorie"]?.value);
      body.append("types_document_id", formData["Type"]?.value);
      body.append("annee_id", formData["Année"]?.value);
      if (formData["Fichier"]) {
        body.append("fichier", formData["Fichier"]);
      } else if (!existingFile) {
        body.append("delete_fichier", true);
      }

      const response = await fetch(
        `https://www.fluxod.com/${api}/documentation_generales/${id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body,
        }
      );

      if (response.ok) {
        handleNavigate();
      } else {
        const responseData = await response.json();
        if (responseData?.message_validation) {
          responseData.message_validation.forEach((err) => toast.error(err));
        } else {
          toast.error("Une erreur s'est produite");
        }
        setLoading(false);
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
        getCategories();
        getAnnees();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!loading && formData.Catégorie?.value) {
      getTypes(formData.Catégorie.value);
    }
  }, [loading]);

  document.title = "Documentation générale | Edit";

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => setActiveTab("details")}
          >
            Détails Documentation générale
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  const fieldStyle = {
    backgroundColor: "white",
    transition: "all 0.15s ease",
    borderLeft: "3px solid transparent",
    position: "relative",
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/documentation_generales/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Documentation générale
                        </Link>
                        <i className="bx bx-caret-right"></i>
                        {!loading ? (
                          configData?.sil || `#${id}`
                        ) : (
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        )}
                      </h5>
                    </div>
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp;&nbsp;
                        <button
                          onClick={() => {
                            const previousPath = localStorage.getItem("previousPath_" + api);
                            navigate(previousPath || -1);
                          }}
                          className="btn btn-sm btn-soft-secondary"
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </button>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="12">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleIdentificationAccordion}
                                  >
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Identification
                                    </span>
                                    {isIdentificationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isIdentificationAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div className="fields-container" style={{ paddingBottom: "8px" }}>
                                        {/* Nom */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Nom"
                                                >
                                                  Nom
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <input
                                                className="form-control form-control-sm"
                                                type="text"
                                                value={formData["Nom"]}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    "Nom",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Catégorie */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Catégorie"
                                                >
                                                  Catégorie
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              {categoriesData.data.length > 0 ? (
                                                <Select
                                                  styles={styles(false)}
                                                  value={formData["Catégorie"]}
                                                  onChange={(val) =>
                                                    handleInputChange(
                                                      "Catégorie",
                                                      val
                                                    )
                                                  }
                                                  options={renderSelectOptions(
                                                    categoriesData.data
                                                  )}
                                                  classNamePrefix="select2-selection"
                                                  menuPortalTarget={document.body}
                                                  isClearable
                                                  placeholder="Sélectionner..."
                                                />
                                              ) : (
                                                <span style={{ fontSize: "0.8rem" }}>
                                                  {formData["Catégorie"]?.label || "——"}
                                                </span>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Type */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Type"
                                                >
                                                  Type
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              {typesData.data.length > 0 ? (
                                                <Select
                                                  styles={styles(false)}
                                                  value={formData["Type"]}
                                                  onChange={(val) =>
                                                    handleInputChange(
                                                      "Type",
                                                      val
                                                    )
                                                  }
                                                  options={renderSelectOptions(
                                                    typesData.data
                                                  )}
                                                  classNamePrefix="select2-selection"
                                                  menuPortalTarget={document.body}
                                                  isClearable
                                                  placeholder="Sélectionner..."
                                                />
                                              ) : (
                                                <span style={{ fontSize: "0.8rem" }}>
                                                  {formData["Type"]?.label || "——"}
                                                </span>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Année */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Année"
                                                >
                                                  Année
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              {anneesData.data.length > 0 ? (
                                                <Select
                                                  styles={styles(false)}
                                                  value={formData["Année"]}
                                                  onChange={(val) =>
                                                    handleInputChange(
                                                      "Année",
                                                      val
                                                    )
                                                  }
                                                  options={renderSelectOptions(
                                                    anneesData.data
                                                  )}
                                                  classNamePrefix="select2-selection"
                                                  menuPortalTarget={document.body}
                                                  isClearable
                                                  placeholder="Sélectionner..."
                                                />
                                              ) : (
                                                <span style={{ fontSize: "0.8rem" }}>
                                                  {formData["Année"]?.label || "——"}
                                                </span>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Fichier */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Fichier"
                                                >
                                                  Fichier
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              {(() => {
                                                const fileName = formData["Fichier"]
                                                  ? formData["Fichier"].name
                                                  : existingFile
                                                    ? (typeof existingFile === "object" && existingFile.filename
                                                        ? existingFile.filename
                                                        : (typeof existingFile === "string" ? existingFile.split("/").pop() : "Fichier"))
                                                    : null;
                                                const fileHref = formData["Fichier"]
                                                  ? newFileUrl
                                                  : existingFile
                                                    ? (typeof existingFile === "object" ? existingFile.url : existingFile)
                                                    : null;
                                                return (
                                                  <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                                    <input
                                                      ref={fileInputRef}
                                                      type="file"
                                                      accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                      style={{ display: "none" }}
                                                      onChange={(e) => {
                                                        const file = e.target.files[0] || null;
                                                        handleInputChange("Fichier", file);
                                                      }}
                                                    />
                                                    <div
                                                      className="form-control form-control-sm"
                                                      style={{ display: "flex", alignItems: "stretch", padding: 0, overflow: "hidden", paddingRight: "1.4rem", cursor: "default" }}
                                                    >
                                                      <span
                                                        onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          padding: "0 0.6rem",
                                                          background: "#e9ecef",
                                                          borderRight: "1px solid #ced4da",
                                                          whiteSpace: "nowrap",
                                                          fontSize: "0.7109375rem",
                                                          color: "#212529",
                                                          flexShrink: 0,
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        Choisir un fichier
                                                      </span>
                                                      {fileHref ? (
                                                        <a
                                                          href={fileHref}
                                                          target="_blank"
                                                          rel="noreferrer"
                                                          title={fileName}
                                                          style={{
                                                            flex: 1,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            paddingLeft: "0.5rem",
                                                            overflow: "hidden",
                                                            fontSize: "0.7109375rem",
                                                            color: "#495057",
                                                            textDecoration: "none",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis",
                                                          }}
                                                        >
                                                          {fileName}
                                                        </a>
                                                      ) : (
                                                        <span style={{
                                                          flex: 1,
                                                          display: "flex",
                                                          alignItems: "center",
                                                          paddingLeft: "0.5rem",
                                                          overflow: "hidden",
                                                          fontSize: "0.7109375rem",
                                                          color: "#495057",
                                                          whiteSpace: "nowrap",
                                                          textOverflow: "ellipsis",
                                                        }}>
                                                          {fileName || "Aucun fichier choisi"}
                                                        </span>
                                                      )}
                                                    </div>
                                                    {(existingFile || formData["Fichier"]) && (
                                                      <button
                                                        type="button"
                                                        onClick={() => {
                                                          setExistingFile(null);
                                                          handleInputChange("Fichier", null);
                                                          if (fileInputRef.current) fileInputRef.current.value = "";
                                                        }}
                                                        title="Supprimer le fichier"
                                                        style={{
                                                          position: "absolute",
                                                          right: "4px",
                                                          top: "50%",
                                                          transform: "translateY(-50%)",
                                                          background: "none",
                                                          border: "none",
                                                          padding: "0 2px",
                                                          cursor: "pointer",
                                                          color: "#aaa",
                                                          lineHeight: 1,
                                                          fontSize: "1rem",
                                                        }}
                                                        onMouseEnter={(e) => (e.currentTarget.style.color = "#dc3545")}
                                                        onMouseLeave={(e) => (e.currentTarget.style.color = "#aaa")}
                                                      >
                                                        <i className="bx bx-x"></i>
                                                      </button>
                                                    )}
                                                  </div>
                                                );
                                              })()}
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditDocumentationGenerale;
